/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationCustomerGranteesMutation from '../graphql/mutations/SaveSimulationCustomerGranteesMutation.js';

export const useSaveSimulationCustomerGranteesMutation = () => {
  return useCommitMutation(SaveSimulationCustomerGranteesMutation, {
    dataProp: 'saveSimulationCustomerGrantees_M_simulation_customer_grantees'
  });
};

export default useSaveSimulationCustomerGranteesMutation;
